/** DEMO-ONLY: catalog manufacturer SKU → UNSPSC (from product detail fixtures).
 * Used so product-list stubs (which omit UNSPSC) still match UNSPSC search terms.
 * Auto-derived from src/assets/mock-data/products/{sku}/get.json — regenerate if fixtures change.
 */
export const PRESIDIO_SKU_TO_UNSPSC: Record<string, string> = {
  "1250g": "43211711",
  "32UN880": "43211902",
  "3R02047": "43211600",
  "4001dn": "43212105",
  "4301fdw": "43212105",
  "45-248-026": "43211902",
  "7000E": "432113300",
  "747": "44103103",
  "75UR640S": "43211902",
  "A7516": "43211600",
  "AMD-MI300X": "432110700",
  "AMD-MI325X": "432110700",
  "AP8858": "39121000",
  "ATA191": "43222609",
  "BDL-AI-LAB": "81112200",
  "BDL-CLOUD": "432114600",
  "BDL-EDGE": "81112200",
  "BDL-SEC": "432114100",
  "BRIO-4K": "43191500",
  "C210E": "44103103",
  "C9200-48P": "43222609",
  "C9300L-48P": "43222609",
  "C9400-Chassis": "43222609",
  "C9500-48Y4C": "43222609",
  "CCS-720XP": "43222600",
  "CISCO-C9300": "43222609",
  "CL-15": "43211503",
  "CP-8841": "43222609",
  "CP-8865": "43222609",
  "CS-KIT-MINI": "43222609",
  "CSF-3105": "43222609",
  "CT16G56C46S5": "43201800",
  "CT8G4DFRA32": "43201800",
  "DCS-7050X3": "43222600",
  "DCS-7130": "43222609",
  "DCS-7280R3": "43222600",
  "DCS-7800R3": "43222600",
  "DDN-AI200": "43201800",
  "DDN-AI400X2": "43201800",
  "DDN-EXA9": "43201800",
  "DDN-IME": "43201800",
  "DDN-SFA18K": "43201800",
  "DEF-UNI": "43191501",
  "DELL-AI-STOR-60": "43201800",
  "DELL-ECS-EX300": "43201800",
  "DELL-MX760C": "432113500",
  "DELL-PMAX2500": "43201800",
  "DELL-PSTORE500": "43201800",
  "DELL-R660": "432112200",
  "DELL-R750": "432110600",
  "DELL-R760XA": "432112600",
  "DELL-SC5020": "43201800",
  "DELL-T550": "43211507",
  "DELL-XE8640": "43211602",
  "DELL-XE9680": "43211602",
  "DELL-XR11": "432111600",
  "DELL-XR4000": "432114100",
  "DS-1630": "43211711",
  "E24-G5": "43211902",
  "ED800-G9": "43211503",
  "EV2-85": "43191500",
  "EX4400-48MP": "43222600",
  "EX4650-48Y": "43222600",
  "FAC-300F": "432112300",
  "FAZ-300F": "432110200",
  "FG-100F": "432112600",
  "FG-600F": "432110100",
  "fi-8170": "43211711",
  "FOCUS2": "43191500",
  "FPR-2130": "43222609",
  "FTNT-SASE-B": "432113900",
  "FW-86BZ30L": "43211902",
  "GA04815": "43191501",
  "HPE-ALL-6050": "43201800",
  "HPE-C7000": "432114100",
  "HPE-DL360-G11": "432113900",
  "HPE-DL380-PERF": "432112500",
  "HPE-DL560-G11": "432112300",
  "HPE-EL8000": "432110700",
  "HPE-ML350-G11": "43211507",
  "HPE-NIM-HF20": "43201800",
  "HPE-PRIM-A650": "43201800",
  "HPE-RL300": "432113500",
  "HPE-SO-3660": "43201800",
  "IE-3400": "43222609",
  "IFP4320": "43211902",
  "IPHONE15-128": "43191501",
  "IPHONE15P-256": "43191501",
  "ISE-3695": "43222609",
  "ISR4331-V": "43222609",
  "J9772A": "43222600",
  "JL624A": "43222600",
  "JL661A": "43222600",
  "KSM56R46BD4": "43201800",
  "LAT-5540": "43211503",
  "LAT-7440": "43211503",
  "LEN-SE450": "43211503",
  "LEN-SE70": "43211503",
  "LEN-SR630-V3": "43211503",
  "LEN-SR650-V3": "43211503",
  "LEN-SR850-V3": "43211503",
  "LSM1U": "43211902",
  "LW-550": "43212105",
  "M321R4GA3BB0": "43201800",
  "M321R8GA0BB0": "43201800",
  "M800": "43191500",
  "MDM-KIT": "81112200",
  "MFC-L5900DW": "43212105",
  "MK2D3": "43211600",
  "MW632ST": "432114100",
  "MX-KEYS": "43211600",
  "MX3S": "43211600",
  "MZ-V8P2T0": "43201800",
  "N9K-C9336C": "43222609",
  "N9K-C9364D": "43222609",
  "NTAP-A250": "43201800",
  "NTAP-A400": "43201800",
  "NTAP-A700": "43201800",
  "NTAP-A800": "43201800",
  "NTAP-CVO": "432111400",
  "NTAP-FAS2750": "43201800",
  "NTAP-ONTAP-AI": "43201800",
  "NTAP-SG": "43201800",
  "NV-6000-ADA": "43211602",
  "NV-A40": "43211602",
  "NV-A6000": "43211602",
  "NV-B100": "43211602",
  "NV-DGX-A100": "43211602",
  "NV-DGX-B200": "43211602",
  "NV-DGX-GB200": "43211602",
  "NV-DGX-H100": "43211602",
  "NV-DGX-STN": "43211602",
  "NV-H100-PCIE": "43211602",
  "NV-H200-PCIE": "43211602",
  "NV-HGX-B200": "43211602",
  "NV-HGX-H100": "43211602",
  "NV-HGX-H200": "43211602",
  "NV-L4-24G": "43211602",
  "NV-L40-48G": "43211602",
  "NV-L40S-24": "432110700",
  "NV-L40S-24-1U-3Y": "432113600",
  "NV-L40S-24-1U-5Y": "432111900",
  "NV-L40S-24-2U-3Y": "432113700",
  "NV-L40S-24-2U-5Y": "432110600",
  "NV-L40S-48": "432113000",
  "NV-L40S-48-1U-3Y": "432113000",
  "NV-L40S-48-1U-5Y": "432110600",
  "NV-L40S-48-2U-3Y": "432114200",
  "NV-L40S-48-2U-5Y": "432111100",
  "NV-L40S-48G": "43211602",
  "NV-L40S-CFG": "432110300",
  "OPTI-7010": "43211507",
  "PA-3220": "432114500",
  "PA-5450": "432113100",
  "PAN-M-100": "432112000",
  "PAN-PRISMA-K": "432113300",
  "PL-4K": "432112000",
  "PRS-AI-STARTER": "432112400",
  "PRS-API-SEC": "43222600",
  "PRS-ARCH-1": "43201800",
  "PRS-ARCH-DISK": "43201800",
  "PRS-BARE-1": "432112100",
  "PRS-BKP-100": "43201800",
  "PRS-CORE-100": "43222609",
  "PRS-CRYPT-GW": "43201800",
  "PRS-CTRL-3": "432111200",
  "PRS-DELL-R760": "432114900",
  "PRS-DNS-SEC": "43222600",
  "PRS-EDGE-AP": "43222609",
  "PRS-EDGE-FW": "43222501",
  "PRS-EDGE-INF": "43211602",
  "PRS-EDGE-KIT": "432113900",
  "PRS-EDGE-MINI": "432112600",
  "PRS-EDGE-SW": "43222609",
  "PRS-EMAIL-SEC": "432111200",
  "PRS-FAB-KIT": "43222609",
  "PRS-FC-KIT": "43201800",
  "PRS-FTNT-FG": "432114800",
  "PRS-GDS-1": "43211602",
  "PRS-GPU-W1": "43211602",
  "PRS-HCI-3": "432111800",
  "PRS-HPE-DL380": "432114000",
  "PRS-HYB-20": "43201800",
  "PRS-HYB-80": "43201800",
  "PRS-IDP-1": "432114900",
  "PRS-IDS-1": "432113600",
  "PRS-IND-8": "43222609",
  "PRS-K8S-N1": "432112100",
  "PRS-LAB-STOR": "43201800",
  "PRS-LAB-STOR2": "43201800",
  "PRS-LEAF-25": "43222600",
  "PRS-META-1": "43201800",
  "PRS-MG-24": "43222609",
  "PRS-MOUSE-OPT": "43211600",
  "PRS-MSEG-1": "43222600",
  "PRS-NAC-1": "432112500",
  "PRS-NAS-48": "43201800",
  "PRS-NFS-GW": "43201800",
  "PRS-NVME-100": "43201800",
  "PRS-OBJ-200": "43201800",
  "PRS-OBJ-50": "43201800",
  "PRS-OMNI-WS": "432113400",
  "PRS-OOB-24": "43222609",
  "PRS-OT-SEC": "43222600",
  "PRS-POE-48": "43222600",
  "PRS-PURE-X20": "43201800",
  "PRS-RAG-1": "43211602",
  "PRS-REPL-1": "43201800",
  "PRS-S3-GW": "43201800",
  "PRS-SAN-ISCSI": "43201800",
  "PRS-SASE-1": "432112000",
  "PRS-SMB-1": "43201800",
  "PRS-SOC-SENS": "432110200",
  "PRS-SPINE-400": "43222600",
  "PRS-STUDIO": "432113500",
  "PRS-SVC-AI-ASSESS": "81112200",
  "PRS-SVC-DEPLOY": "81112200",
  "PRS-T2-BUF": "43201800",
  "PRS-TRN-POD4": "43211602",
  "PRS-VEEAM-R": "43201800",
  "PRS-VPN-C": "432111300",
  "PRS-WAF-1": "432112800",
  "PRS-WIFI-SW": "43222609",
  "PS-16C": "432110700",
  "PSU-1600T": "39121000",
  "PURE-CBR": "43201800",
  "PURE-CBS-LIC": "81112200",
  "PURE-FAC": "43201800",
  "PURE-FAX": "43201800",
  "PURE-FAXL": "43201800",
  "PURE-FB": "43201800",
  "PURE-FBE": "43201800",
  "PURE-FBX": "43201800",
  "PURE-PX-ESS": "43201800",
  "PX3-5490V": "39121000",
  "Q1": "43211600",
  "QFX10002-72Q": "43222609",
  "QFX5120-48Y": "43222600",
  "QN65Q60C": "43211902",
  "R8S96A": "43222609",
  "RALLY-CAM": "43191500",
  "S34C650": "43211902",
  "SATURN3I": "432112200",
  "SM-G736": "43191501",
  "SM-S921": "43191501",
  "SMCI-1U-GPU": "43211602",
  "SMCI-221H": "432114000",
  "SMCI-4L40S": "43211602",
  "SMCI-4U-SDS": "43201800",
  "SMCI-EDGE-1": "432112400",
  "SMCI-HGX-8H100": "43211602",
  "SMT1500": "39121000",
  "SMT3000": "39121000",
  "SMX120BP": "432112900",
  "SPEAK750": "43191500",
  "STU-540": "432113600",
  "STUDIO-X50": "43191500",
  "SUPPORT-3YR": "81112200",
  "SVC-ARCH": "81112200",
  "SVC-BKP-OPS": "81112200",
  "SVC-CABLE": "81112200",
  "SVC-DISC": "81112200",
  "SVC-DR": "81112200",
  "SVC-FINOPS": "81112200",
  "SVC-FTE": "81112200",
  "SVC-FW": "81112200",
  "SVC-GPU-OPS": "81112200",
  "SVC-HEALTH": "81112200",
  "SVC-HYPER": "81112200",
  "SVC-IAC": "81112200",
  "SVC-K8S": "81112200",
  "SVC-MIG": "81112200",
  "SVC-NET": "81112200",
  "SVC-NOC": "81112200",
  "SVC-OPS-MO": "81112200",
  "SVC-PATCH": "81112200",
  "SVC-SEC-A": "81112200",
  "SVC-STOR": "81112200",
  "SVC-TRAIN": "81112200",
  "SVC-WLAN": "81112200",
  "SVC-ZT-DES": "81112200",
  "T14-G5": "43211503",
  "T630-24": "43212105",
  "TR-STD": "81112200",
  "TS4": "43211600",
  "U2723QE": "43211902",
  "U4924DW": "43211902",
  "UMB-SIG-KIT": "43222609",
  "UN55CU7000": "43211902",
  "USB4-08": "43211600",
  "VAST-AI-STOR": "43201800",
  "VAST-CBOX": "43201800",
  "VAST-DNODE": "43201800",
  "VAST-SNAP": "43201800",
  "VVX-450": "43191500",
  "W2020A": "44103103",
  "W2021-23A": "44103103",
  "WD19S": "43211600",
  "WEKA-EDGE": "43201800",
  "WEKA-NODE": "43201800",
  "WEKA-SCALE": "43201800",
  "ZBOOK-F16": "43211503",
  "ZD421": "43212105",
};

/** Digits-only form for dotted / spaced UNSPSC codes (e.g. 43.21.15.08 → 43211508). */
export function normalizePresidioUnspsc(value: string | undefined | null): string {
  return String(value || '').replace(/\D+/g, '');
}

/**
 * UNSPSC search tokens must be at least 4 digits and match as a full code or prefix.
 * Blocks short numeric false positives (e.g. "160" inside 43211600).
 */
export function unspscMatchesSearchToken(
  unspsc: string | undefined | null,
  token: string | undefined | null
): boolean {
  const unspscDigits = normalizePresidioUnspsc(unspsc);
  const tokenDigits = normalizePresidioUnspsc(token);
  if (!unspscDigits || !tokenDigits || tokenDigits.length < 4) {
    return false;
  }
  return unspscDigits === tokenDigits || unspscDigits.startsWith(tokenDigits);
}

export function lookupPresidioUnspsc(sku: string | undefined | null): string | undefined {
  const key = String(sku || '').trim();
  if (!key) {
    return undefined;
  }
  return PRESIDIO_SKU_TO_UNSPSC[key] ?? PRESIDIO_SKU_TO_UNSPSC[key.toUpperCase()] ?? PRESIDIO_SKU_TO_UNSPSC[key.toLowerCase()];
}
